<template>
  <div id="modifierNavigation" class="tabs">
    <router-link class="tab" :to="{ path: '/modifiers', query: query}">{{$t("inventory.modifiers")}}</router-link>
    <router-link class="tab" :to="{ path: '/modifier-groups', query: query}">{{$t("inventory.modifiers_groups")}}</router-link>
  </div>
</template>

<script>
  export default {
    name: "modifierNaviguation",

    data() {
      return {
        query: {
          branch: this.$route.query.branch,
          company: this.$route.query.company ? this.$route.query.company : undefined
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tab {
    cursor: pointer;
  }
</style>